import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { ensureWebStorage } from '@icamppro-customer-portal/shared/cmp-base';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Guard against browsers that block Web Storage (Safari "Block All Cookies",
// Firefox strict). Installs an in-memory fallback so the app never crashes on access.
ensureWebStorage();

platformBrowser().bootstrapModule(AppModule, {
  applicationProviders: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
  ],
})
  .catch(err => console.error(err));
